<template>
  <div class="reimburseDetail">
    <OACard header="报销详情">
      <el-button
        v-if="detail.spStatus==2"
        slot="button"
        class="pull-right"
        type="text"
        @click="download"
      >下载PDF</el-button>
      <form-component :form-data="formData" ref="formData" label-width="160px"></form-component>
    </OACard>
    <OACard header="报销明细" v-for="x in num" :key="x">
      <form-component :form-data="formDetail[x-1]" ref="formDetail" label-width="160px"></form-component>
    </OACard>
  </div>
</template>
<script>
import OACard from "@/components/OACard/OACard";
import formComponent from "@/components/formComponents/form-component";
import { iconList } from "@/common/dictionary";
import reimburseApi from "@/services/reimburse.js";
import { getUrlQuery, setValue, download } from "@/common/util.js";

export default {
  name: "reimburseDetail",
  components: { formComponent, OACard },
  data() {
    return {
      iconList: iconList,
      formData: {
        spNum: {
          formType: "a-span",
          value: "-",
          col: 12,
          label: "审批编号："
        },
        applyTime: {
          formType: "a-span",
          value: "-",
          col: 12,
          label: "提交时间："
        },
        employeeName: {
          formType: "a-span",
          value: "-",
          col: 12,
          label: "申请人："
        },
        departmentName: {
          formType: "a-span",
          value: "-",
          col: 12,
          label: "申请人部门："
        },
        spStatusName: {
          formType: "a-span",
          value: "-",
          col: 12,
          label: "当前审批状态："
        },
        approvalName: {
          formType: "a-span",
          value: "-",
          col: 12,
          label: "审批人："
        }
      },
      formDetail: {},
      detail: {},
      query: {},
      num: 0
    };
  },
  mounted() {
    this.query = getUrlQuery();
    this.getDetail(this.query.id);
  },
  methods: {
    async getDetail(id) {
      let res = await reimburseApi.getApprovalDetails({ id: id });
      this.detail = res.data.data;
      this.num = this.detail.wechatApprovalValues.length;
      setValue(this.detail, this.formData);
      this.getContent(this.detail.wechatApprovalValue, this.formData);
      this.getItem(this.detail.wechatApprovalValues, this.formDetail);
      this.getfile();
    },
    getItem(data, form) {
      //获取报销明细
      data.map((value, index) => {
        form[index] = {};
        this.getContent(value, form[index]);
      });
    },
    getContent(data, form) {
      data.map((value, index) => {
        form["value" + index] = {
          formType: "a-span",
          value: value.value || "-",
          col: 12,
          label: value.title + "："
        };
      });
    },
    getfile() {
      //获取发票照片
      this.formData["file"] = {
        formType: "sky-upload-img",
        value: this.detail.file,
        disabled: true,
        label: "发票照片/扫描：",
        platform: 'oa-pri-oss',
      };
    },
    async download() {
      let res = await reimburseApi.downloadpdf({ id: this.query.id });
      download(res.data.data);
    }
  }
};
</script>
<style lang="scss">
.reimburseDetail {
  .OAButton {
    line-height: 40px;
  }
  .el-steps {
    margin: 10px 30px;
    &.is-error {
      .el-icon-error {
        color: #f56c6c;
      }
      .is-process {
        color: #f56c6c;
      }
      .el-step {
        min-height: 60px;
        .el-step__description {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reimburse/reimburseDetail.vue